import { defineSmartFeedPiniaStore } from "@bloglovin/vue-framework";
import SmartFeedEngine from "SmartFeed/smart-feed-engine";
import useFanPublicationStore from "%/stores/fan-publication-store";

export const useExclusiveStoryFeedStore = defineSmartFeedPiniaStore("exclusive-story-feed-store", {
  state: () => ({
    smartFeedEngine: new SmartFeedEngine(),
    metadata: {
      lastId: Number.MAX_SAFE_INTEGER,
      publicationId: useFanPublicationStore().publicationId,
    },
  }),
  getters: {
    feedUrl() {
      return `publication/${this.metadata.publicationId}/stories/exclusive/smart-feed`;
    },
    smartFeedRequestGetParams() {
      return {
        last_id: this.metadata.lastId,
        user_id: this.metadata.userId,
      };
    },
  },
});
